import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ToastMessage } from '@shared/components/toast-message/toast-message';
import { CustomTranslateService } from '@shared/services/custom-translate.service';
import { Subject, takeUntil } from 'rxjs';
import { PrimeNGI18nService } from 'src/assets/i18n/primeng-i18n.service';
import { LoginService } from './features/login/login.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastMessage],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  title = 'IHI-safety';
  isLogin: boolean = false;
  destroy = new Subject<void>();
  constructor(
    private readonly customTranslateService: CustomTranslateService,
    private readonly loginService: LoginService,
    _: PrimeNGI18nService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.customTranslateService.initI18n();
    this.customTranslateService.setLanguage(localStorage?.getItem('lang')!);
  }

  ngOnInit(): void {
    this.loginService.isLogin.pipe(takeUntil(this.destroy)).subscribe({
      next: value => {
        if (window.location.href.includes('resetPassword')) {
          //  this.isLogin = true;
        } else if (value) {
          this.customTranslateService.setLanguage(localStorage?.getItem('lang')!);
          //  this.isLogin = value;
        }
      },
    });
  }
  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
